import { Music } from "@hg/media"

export const bgm = new Music({
    src: require("./bgm.wav"),
    loop: true,
    autoPlay: true,
    suspendWhenHidden: true,
    suspendWhenHiddenInSkland: true,
})
